// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .sub-menu {
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
    padding: 20px 20px 20px 30px;
    display: flex;
    justify-content: space-between;
 }

 .box-title {
    align-items: center;
    border-bottom: 1px solid #0a0a0a;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
    display: flex;
    justify-content: space-between;
    padding-right: 100px;
    margin-left: 10px;
 }

 .box span {
   color: #999;
 }
 .box-content {
    margin: 0px 10px 0px 10px;
 }

 .container {
   display: flex;
 }


 .box-feature mat-icon{
   font-weight: bold;
   color: black;
 }

 .box p {
    display: flex;
    align-items: center;
  }

 .menu-title-text{
    font-size: 20px;
  }
 
 .sub-menu a{
    cursor: pointer;
    margin-left: 30px;
  }

  .sub-menu-label{
    width: 90%; 
    font-size: 14px;
  }
  .right-element {
    margin-left: auto;
    white-space: nowrap;

  }

  .menu-title {
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);

    padding: 15px 10px 5px 0;
 }

  .container-profile {
    flex: 1;
    background: #fff;
    margin: 0 30px;
 }

 .edit-button{
    text-decoration-line: underline;
    font-weight: bold;
   }


   .check-icon {
      transform: scale(0.6);
   }


  .box {
    border: 1px solid black;
    padding: 10px;
    display: inline-block;
    min-width: 300px;
    min-height: auto;
    margin: 10px 10px 10px 10px;
  }


  .storage-container {
    width: 200px;
    height: 20px;
    background-color: #eee;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .progress-bar{ 
    height:18px;
    pointer-events: none;
 }

 .plan-progress-form {
    padding: 15px 20px 20px 20px;
 }


 .plan-progress-form .mat-progress-bar-fill::after {
    background-color: green !important;
}
 .bg-box{
    margin-right: 5px;
    border: 1px solid black;
    width: 15px;
    height: 15px;
 }

 .bg-status {
   margin: -10px -10px 5px;
   height: 5px;
 }

.bg-green{
 background-color: rgb(119, 224, 119);
}

.bg-gray{
   background-color: gray;
}

 .bg-box-gray {
    background-color: gray;
 }

 .bg-box-gainsboro {
    background-color: gainsboro;
 }

 .max-space{
    font-size:14px!important;
    margin-top: 5px;
 }
 ::ng-deep .plan-progress-form .mat-progress-bar .mat-progress-bar-fill::after {
    background-color: gray;
  }

  ::ng-deep .plan-progress-form .mat-progress-bar .mat-progress-bar-buffer{
        background-color: gainsboro;
}
  `, "",{"version":3,"sources":["webpack://./src/app/account/profile/plan/plan.component.css"],"names":[],"mappings":";EACE;IACE,mBAAmB;IACnB,gCAAgC;IAChC,6CAA6C;IAC7C,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;CACjC;;CAEA;IACG,mBAAmB;IACnB,gCAAgC;IAChC,6CAA6C;IAC7C,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,iBAAiB;CACpB;;CAEA;GACE,WAAW;CACb;CACA;IACG,yBAAyB;CAC5B;;CAEA;GACE,aAAa;CACf;;;CAGA;GACE,iBAAiB;GACjB,YAAY;CACd;;CAEA;IACG,aAAa;IACb,mBAAmB;EACrB;;CAED;IACG,eAAe;EACjB;;CAED;IACG,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,mBAAmB;;EAErB;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;IAChC,6CAA6C;;IAE7C,wBAAwB;CAC3B;;EAEC;IACE,OAAO;IACP,gBAAgB;IAChB,cAAc;CACjB;;CAEA;IACG,+BAA+B;IAC/B,iBAAiB;GAClB;;;GAGA;MACG,qBAAqB;GACxB;;;EAGD;IACE,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;;;EAGA;IACE,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,oBAAoB;CACvB;;CAEA;IACG,4BAA4B;CAC/B;;;CAGA;IACG,kCAAkC;AACtC;CACC;IACG,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,YAAY;CACf;;CAEA;GACE,uBAAuB;GACvB,WAAW;CACb;;AAED;CACC,oCAAoC;AACrC;;AAEA;GACG,sBAAsB;AACzB;;CAEC;IACG,sBAAsB;CACzB;;CAEA;IACG,2BAA2B;CAC9B;;CAEA;IACG,wBAAwB;IACxB,eAAe;CAClB;CACA;IACG,sBAAsB;EACxB;;EAEA;QACM,2BAA2B;AACnC","sourcesContent":["\n  .sub-menu {\n    align-items: center;\n    border-bottom: 1px solid #eaeaea;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n    padding: 20px 20px 20px 30px;\n    display: flex;\n    justify-content: space-between;\n }\n\n .box-title {\n    align-items: center;\n    border-bottom: 1px solid #0a0a0a;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n    display: flex;\n    justify-content: space-between;\n    padding-right: 100px;\n    margin-left: 10px;\n }\n\n .box span {\n   color: #999;\n }\n .box-content {\n    margin: 0px 10px 0px 10px;\n }\n\n .container {\n   display: flex;\n }\n\n\n .box-feature mat-icon{\n   font-weight: bold;\n   color: black;\n }\n\n .box p {\n    display: flex;\n    align-items: center;\n  }\n\n .menu-title-text{\n    font-size: 20px;\n  }\n \n .sub-menu a{\n    cursor: pointer;\n    margin-left: 30px;\n  }\n\n  .sub-menu-label{\n    width: 90%; \n    font-size: 14px;\n  }\n  .right-element {\n    margin-left: auto;\n    white-space: nowrap;\n\n  }\n\n  .menu-title {\n    align-items: center;\n    border-bottom: 1px solid #eaeaea;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n\n    padding: 15px 10px 5px 0;\n }\n\n  .container-profile {\n    flex: 1;\n    background: #fff;\n    margin: 0 30px;\n }\n\n .edit-button{\n    text-decoration-line: underline;\n    font-weight: bold;\n   }\n\n\n   .check-icon {\n      transform: scale(0.6);\n   }\n\n\n  .box {\n    border: 1px solid black;\n    padding: 10px;\n    display: inline-block;\n    min-width: 300px;\n    min-height: auto;\n    margin: 10px 10px 10px 10px;\n  }\n\n\n  .storage-container {\n    width: 200px;\n    height: 20px;\n    background-color: #eee;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  \n  .progress-bar{ \n    height:18px;\n    pointer-events: none;\n }\n\n .plan-progress-form {\n    padding: 15px 20px 20px 20px;\n }\n\n\n .plan-progress-form .mat-progress-bar-fill::after {\n    background-color: green !important;\n}\n .bg-box{\n    margin-right: 5px;\n    border: 1px solid black;\n    width: 15px;\n    height: 15px;\n }\n\n .bg-status {\n   margin: -10px -10px 5px;\n   height: 5px;\n }\n\n.bg-green{\n background-color: rgb(119, 224, 119);\n}\n\n.bg-gray{\n   background-color: gray;\n}\n\n .bg-box-gray {\n    background-color: gray;\n }\n\n .bg-box-gainsboro {\n    background-color: gainsboro;\n }\n\n .max-space{\n    font-size:14px!important;\n    margin-top: 5px;\n }\n ::ng-deep .plan-progress-form .mat-progress-bar .mat-progress-bar-fill::after {\n    background-color: gray;\n  }\n\n  ::ng-deep .plan-progress-form .mat-progress-bar .mat-progress-bar-buffer{\n        background-color: gainsboro;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
